import { Injectable } from "@angular/core";

import { Observable, of } from "rxjs";

import { DirectoryItemModel } from "../models/directory-item.model";
import { DirectorySearchParametersModel } from "../models/directory-search-parameters.model";
import { catchError } from "rxjs/operators";
import { BaseSearchResultsModel } from "../../../models/base-search-results.model";
import { ApiRequestDispatcherService } from "../../../api/api-request-dispatcher.service";

@Injectable({
    providedIn: "root"
})
export class DirectorySearchService {
    private readonly API_GET_LIST_URL = "/api/s4s-advanced-search/directory-search/get-list";

    public constructor(
        private _requestDispatcher: ApiRequestDispatcherService
    ) {
    }

    public getSearchResults(searchParams: DirectorySearchParametersModel): Observable<BaseSearchResultsModel<DirectoryItemModel>> {
        return this._requestDispatcher.get<BaseSearchResultsModel<DirectoryItemModel>>(this.API_GET_LIST_URL, { searchParams: JSON.stringify(searchParams) }).pipe(
            catchError((error) => {
                console.error(error);
                return of({ pageNumber: 1, pageSize: searchParams.pageSize, totalPages: 0, totalItems: 0, pageItems: [], recommendedLinks: [] });
            })
        );
    }
}
